/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';
import { isValidToken } from '../../../../lib/isValidToken';

export default connectRequests((state, props) => {
  const token = state.token;
  const instanceKey = props.match.params.instanceKey;
  let instancePreviewUrl = instanceKey
    ? `/instances/${instanceKey}/status/preview?locale=en`
    : `/instanceAliases/${props.match.params.aliasKey}/status/preview`;
  const queryParam = props.location.search;
  const type = queryParam.length > 0 ? queryParam.split('?type=')[1] : '';
  if (type && !instanceKey) instancePreviewUrl += `?type=${type}`;
  return {
    subscribe: {
      method: 'POST',
      url: '/subscribe'
    },
    subscriber: {
      url: `/subscribers?token=${token}&normalize=true`,
      onLoad: isValidToken(token),
    },
    instancePreview: {
      url: instancePreviewUrl,
      onLoad: true
    }
  };
});
